export default {
  state: {
    coursesList: {
      courses: []
    },
    userCoursesList: {
      courses: []
    },
    userRightCoursesList: {
      courses: []
    },
    courseStatistic: [
        {
          user_test_attempts: []
        }
    ],
    userStatistic: {},
    stagesList: [
      {
        type: 0,
        text_material: {},
        test_material: {},
        file_materials: {},
        user: {}
      }
    ],
    infoStagesList: [],
    stageInfo: {
      course: {},
      material: {}
    },
    courseInfo: {
      course: {
        category: {},
        stages: []
      }
    },
    courseProfileInfo: {
      course: {
        category: {},
        stages: []
      }
    },
    coursePageInfo: {
      course: {
        category: {}
      }
    },
    currentUserStatistic: {},
    currentUserStatisticStage: {},

  },
  mutations: {
    setUserCoursesList: (state, { list }) => {
      state.userCoursesList = list
    },
    setUserRightCoursesList: (state, { list }) => {
      state.userRightCoursesList = list
    },
    setCoursesList: (state, { list }) => {
      state.coursesList = list
    },
    setCourseStatistic: (state, { list }) => {
      state.courseStatistic = list
    },
    setUserStatistic: (state, { list }) => {
      state.userStatistic = list
    },
    setStagesList: (state, { list }) => {
      state.stagesList = list
    },
    setInfoStagesList: (state, { list }) => {
      state.infoStagesList = list
    },
    setStageInfo: (state, { list }) => {
      state.stageInfo = list
    },
    setCourseInfo: (state, { list }) => {
      state.courseInfo = list
    },
    setCourseProfileInfo: (state, { list }) => {
      state.courseProfileInfo = list
    },
    setCoursePageInfo: (state, { list }) => {
      state.coursePageInfo = list
    },
    setCurrentUserStatistic: (state, data) => {
      state.currentUserStatistic = data
    },
    setCurrentUserStatisticStage: (state, data) => {
      state.currentUserStatisticStage = data
    },
  },
  actions: {}
}
